import { IcAirport } from '@assets/icons/24x24';
import { For, HStack, Text } from '@chakra-ui/react';
import DropSelect from '@components/common/menu/DropSelect';
import { ScrollArea } from '@components/ui/ScrollArea';

import { useMonitoringContext } from './MonitoringContext';

function Header() {
  const { platformFilters, setPlatformFilters } = useMonitoringContext();
  return (
    <HStack justifyContent="start" gap={0.25} paddingX={3} minWidth={0} flex={1}>
      <DropSelect
        icon={IcAirport}
        values={
          new Set(
            platformFilters
              .filter((platformFilter) => platformFilter.active)
              .map((platformFilter) => platformFilter.platform.code),
          )
        }
        options={[...platformFilters].map((platformFilter) => ({
          value: platformFilter.platform.code,
          label: platformFilter.platform.name,
        }))}
        onChange={(values) =>
          setPlatformFilters(
            platformFilters.map((platformFilter) => ({
              platform: platformFilter.platform,
              active: values.has(platformFilter.platform.code),
            })),
          )
        }
      />
      <ScrollArea orientation="horizontal" size="small">
        <HStack gap={0.25} flex={1} minWidth={0}>
          <For each={platformFilters.filter((platformFilter) => platformFilter.active)}>
            {(platformFilter) => (
              <Text
                paddingX={2}
                key={platformFilter.platform.code}
                paddingY="11px"
                backgroundColor="neutral.black"
                flexShrink={0}
                textOverflow="ellipsis"
                overflow="hidden"
              >
                {platformFilter.platform.name}
              </Text>
            )}
          </For>
        </HStack>
      </ScrollArea>
    </HStack>
  );
}

export default Header;
